import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  get(params) {
    return axios.get(adminPath('/invoice_formats?') + prepareQueryString(params)).then((response) => {
      return {
        invoiceFormats: response.data.map((invoiceFormat) => an('InvoiceFormat', invoiceFormat)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
};
